import { alertsConstants } from "../constants/alertsConstants";

const initialState = {
  alertType: null,
  message: null
};

export default function alertsReducer(state = initialState, action = null) {
  const { type, message, alertType, error } = action;
  switch (type) {
    case alertsConstants.RENDER:
    //  console.log('Render');
      return {
        ...state,
        alertType: alertType,
        message: message
      };

    case alertsConstants.CLEAR:
     // console.log('Clear');
      return {
        ...state,
        alertType: null,
        message: null
      };
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/app/redux/reducers/alertsReducer.js